import React from 'react';
import { useNavigate } from 'react-router-dom';
import { routes } from '@/utils/routes';
import { Feature } from '@/config/featureFlags.definition';
import { isFeatureEnabled } from '@/config/featureFlags.service';
import { sideNav } from '@/utils/translations';
import { useApprovalRequiredCount } from '@/features/payments/manage/hooks/useApprovalRequiredCount';
import ApprovalRequiredBadge from '@/features/payments/manage/components/ApprovalRequiredBadge';

export const PaymentsMenu: React.FC = () => {
  const navigate = useNavigate();
  // Called unconditionally (Rules of Hooks) even though the flag check below can bail out before
  // rendering - the hook itself no-ops (see useApprovalRequiredCount) when the feature is off.
  const approvalRequiredCount = useApprovalRequiredCount();

  if (!isFeatureEnabled(Feature.MANAGE_PAYMENT)) return null;

  return (
    <button
      type="button"
      className="flex items-center gap-x-1.5 text-xs leading-6 cursor-pointer"
      onClick={() => navigate(routes.managePayment)}>
      {sideNav.payments}
      <ApprovalRequiredBadge count={approvalRequiredCount} />
    </button>
  );
};
